var _rect, _rect2, _text, _text2, _path, _text3, _text4, _text5, _text6, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _text7, _line, _text8, _text9, _text10, _line2, _line3, _text11, _text12, _text13, _text14, _line4, _line5, _line6;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgXm2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 400 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    className: "layer"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#333333",
    height: 382,
    id: "svg_5",
    stroke: "#000000",
    strokeOpacity: 0,
    strokeWidth: 5,
    width: 382,
    x: 8.5,
    y: 7.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    fill: "#ffffff",
    height: 270.99999,
    id: "svg_6",
    stroke: "#000000",
    strokeOpacity: 0,
    strokeWidth: 5,
    width: 301.99998,
    x: 49.00001,
    y: 46.5
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    fill: "#ffffff",
    fontFamily: "Roboto",
    fontSize: 16,
    fontWeight: "bold",
    id: "svg_7",
    stroke: "#000000",
    strokeDasharray: "null",
    strokeLinecap: "null",
    strokeLinejoin: "null",
    strokeOpacity: 0,
    strokeWidth: 0,
    textAnchor: "middle",
    x: 66.5,
    xmlSpace: "preserve",
    y: 31.5
  }, "Hakaru+")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    fill: "#ffffff",
    fontFamily: "Roboto",
    fontSize: 16,
    fontWeight: "bold",
    id: "svg_8",
    stroke: "#000000",
    strokeDasharray: "null",
    strokeLinecap: "null",
    strokeLinejoin: "null",
    strokeOpacity: 0,
    strokeWidth: 0,
    textAnchor: "middle",
    x: 335,
    xmlSpace: "preserve",
    y: 31.5
  }, "XM2-110")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m87.00001,74.50001a2.24,1.71 0 0 0 223.99999,0",
    fill: "#000000",
    fillOpacity: 0,
    id: "svg_4",
    stroke: "#000000",
    strokeWidth: 2,
    transform: "rotate(-180 199 117.25)"
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    fill: "#ffffff",
    fontFamily: "Roboto",
    fontSize: 14,
    fontWeight: "normal",
    id: "svg_10",
    stroke: "#000000",
    strokeDasharray: "null",
    strokeLinecap: "null",
    strokeLinejoin: "null",
    strokeOpacity: 0,
    strokeWidth: 0,
    textAnchor: "middle",
    x: 336,
    xmlSpace: "preserve",
    y: 349.5
  }, "DISPLAY")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    fill: "#ffffff",
    fontFamily: "Roboto",
    fontSize: 14,
    fontWeight: "normal",
    id: "svg_11",
    stroke: "#000000",
    strokeDasharray: "null",
    strokeLinecap: "null",
    strokeLinejoin: "null",
    strokeOpacity: 0,
    strokeWidth: 0,
    textAnchor: "middle",
    x: 145,
    xmlSpace: "preserve",
    y: 351
  }, "SET     +       -     RESET /MIN")), /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    fontFamily: "Roboto",
    fontSize: 36,
    fontWeight: "bold",
    id: "svg_18",
    stroke: "#000000",
    strokeDasharray: "null",
    strokeLinecap: "null",
    strokeLinejoin: "null",
    strokeOpacity: 0,
    strokeWidth: 0,
    style: {
      cursor: "move"
    },
    textAnchor: "middle",
    x: 214.94531,
    xmlSpace: "preserve",
    y: 190.5
  }, "6600 V"), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    fontFamily: "Roboto",
    fontSize: 36,
    fontWeight: "bold",
    id: "svg_19",
    stroke: "#000000",
    strokeDasharray: "null",
    strokeLinecap: "null",
    strokeLinejoin: "null",
    strokeOpacity: 0,
    strokeWidth: 0,
    textAnchor: "middle",
    x: 206.58594,
    xmlSpace: "preserve",
    y: 244.5
  }, "250.0 A")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    fontFamily: "Roboto",
    fontSize: 36,
    fontWeight: "bold",
    id: "svg_20",
    stroke: "#000000",
    strokeDasharray: "null",
    strokeLinecap: "null",
    strokeLinejoin: "null",
    strokeOpacity: 0,
    strokeWidth: 0,
    textAnchor: "middle",
    x: 211.78906,
    xmlSpace: "preserve",
    y: 299.5
  }, "12345.6 kWh")), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    fill: "#56aaff",
    height: 15,
    id: "svg_1",
    stroke: "#000000",
    strokeDasharray: "null",
    strokeLinecap: "null",
    strokeLinejoin: "null",
    width: 23,
    x: 45.5,
    y: 356.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    fill: "#56aaff",
    height: 15,
    id: "svg_2",
    stroke: "#000000",
    strokeDasharray: "null",
    strokeLinecap: "null",
    strokeLinejoin: "null",
    width: 23,
    x: 87.5,
    y: 356.5
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    fill: "#56aaff",
    height: 15,
    id: "svg_3",
    stroke: "#000000",
    strokeDasharray: "null",
    strokeLinecap: "null",
    strokeLinejoin: "null",
    width: 23,
    x: 129.5,
    y: 356.5
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    fill: "#56aaff",
    height: 15,
    id: "svg_4",
    stroke: "#000000",
    strokeDasharray: "null",
    strokeLinecap: "null",
    strokeLinejoin: "null",
    width: 23,
    x: 178.5,
    y: 356.5
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    fill: "#56aaff",
    height: 15,
    id: "svg_9",
    stroke: "#000000",
    strokeDasharray: "null",
    strokeLinecap: "null",
    strokeLinejoin: "null",
    width: 23,
    x: 221.5,
    y: 356.5
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    fill: "#56aaff",
    height: 15,
    id: "svg_12",
    stroke: "#000000",
    strokeDasharray: "null",
    strokeLinecap: "null",
    strokeLinejoin: "null",
    width: 51,
    x: 312.5,
    y: 355.5
  })), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    fill: "#ffffff",
    fontFamily: "Roboto",
    fontSize: 14,
    fontWeight: "normal",
    id: "svg_13",
    stroke: "#000000",
    strokeDasharray: "null",
    strokeLinecap: "null",
    strokeLinejoin: "null",
    strokeOpacity: 0,
    strokeWidth: 0,
    textAnchor: "middle",
    x: 231,
    xmlSpace: "preserve",
    y: 335.5
  }, "MAX")), _line || (_line = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    fillOpacity: 0,
    id: "svg_14",
    stroke: "#000000",
    strokeDasharray: "null",
    strokeLinecap: "null",
    strokeLinejoin: "null",
    strokeWidth: 2,
    x1: 199,
    x2: 199,
    y1: 73.5,
    y2: 64.4667
  })), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    fontFamily: "Roboto",
    fontSize: 18,
    fontWeight: "normal",
    id: "svg_15",
    stroke: "#000000",
    strokeDasharray: "null",
    strokeLinecap: "null",
    strokeLinejoin: "null",
    strokeOpacity: 0,
    strokeWidth: 0,
    textAnchor: "middle",
    x: 88.5,
    xmlSpace: "preserve",
    y: 185
  }, "50")), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    fontFamily: "Roboto",
    fontSize: 18,
    fontWeight: "normal",
    id: "svg_16",
    stroke: "#000000",
    strokeDasharray: "null",
    strokeLinecap: "null",
    strokeLinejoin: "null",
    strokeOpacity: 0,
    strokeWidth: 0,
    textAnchor: "middle",
    x: 313.5,
    xmlSpace: "preserve",
    y: 183
  }, "50")), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    fontFamily: "Roboto",
    fontSize: 18,
    fontWeight: "normal",
    id: "svg_17",
    stroke: "#000000",
    strokeDasharray: "null",
    strokeLinecap: "null",
    strokeLinejoin: "null",
    strokeOpacity: 0,
    strokeWidth: 0,
    textAnchor: "middle",
    x: 198.5,
    xmlSpace: "preserve",
    y: 62
  }, "100")), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    fillOpacity: 0,
    id: "svg_23",
    stroke: "#000000",
    strokeDasharray: "null",
    strokeLinecap: "null",
    strokeLinejoin: "null",
    strokeWidth: 2,
    x1: 76,
    x2: 87.02499,
    y1: 159.5,
    y2: 159.5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    fillOpacity: 0,
    id: "svg_24",
    stroke: "#000000",
    strokeDasharray: "null",
    strokeLinecap: "null",
    strokeLinejoin: "null",
    strokeWidth: 2,
    x1: 312,
    x2: 323.02499,
    y1: 159.5,
    y2: 159.5
  })), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    fontFamily: "Roboto",
    fontSize: 18,
    fontWeight: "normal",
    id: "svg_25",
    stroke: "#000000",
    strokeDasharray: "null",
    strokeLinecap: "null",
    strokeLinejoin: "null",
    strokeOpacity: 0,
    strokeWidth: 0,
    textAnchor: "middle",
    x: 313.5,
    xmlSpace: "preserve",
    y: 70
  }, "LAG")), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    fontFamily: "Roboto",
    fontSize: 18,
    fontWeight: "normal",
    id: "svg_26",
    stroke: "#000000",
    strokeDasharray: "null",
    strokeLinecap: "null",
    strokeLinejoin: "null",
    strokeOpacity: 0,
    strokeWidth: 0,
    textAnchor: "middle",
    x: 137.5,
    xmlSpace: "preserve",
    y: 134
  }, "RS")), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    fontFamily: "Roboto",
    fontSize: 11,
    fontWeight: "bold",
    id: "svg_27",
    stroke: "#000000",
    strokeDasharray: "null",
    strokeLinecap: "null",
    strokeLinejoin: "null",
    strokeOpacity: 0,
    strokeWidth: 0,
    textAnchor: "middle",
    x: 198.5,
    xmlSpace: "preserve",
    y: 92
  }, "%")), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    fontFamily: "Roboto",
    fontSize: 18,
    fontWeight: "normal",
    id: "svg_28",
    stroke: "#000000",
    strokeDasharray: "null",
    strokeLinecap: "null",
    strokeLinejoin: "null",
    strokeOpacity: 0,
    strokeWidth: 0,
    textAnchor: "middle",
    x: 206.07812,
    xmlSpace: "preserve",
    y: 113
  }, "98.0")), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    fillOpacity: 0,
    id: "svg_29",
    stroke: "#000000",
    strokeDasharray: "null",
    strokeLinecap: "null",
    strokeLinejoin: "null",
    strokeWidth: 2,
    x1: 170,
    x2: 225.02497,
    y1: 118.5,
    y2: 118.5
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    fillOpacity: 0,
    id: "svg_30",
    stroke: "#000000",
    strokeDasharray: "null",
    strokeLinecap: "null",
    strokeLinejoin: "null",
    strokeWidth: 2,
    x1: 151.00001,
    x2: 242.02497,
    y1: 196.5,
    y2: 196.5
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    fillOpacity: 0,
    id: "svg_31",
    stroke: "#000000",
    strokeDasharray: "null",
    strokeLinecap: "null",
    strokeLinejoin: "null",
    strokeWidth: 2,
    x1: 137.00001,
    x2: 237.02497,
    y1: 251.5,
    y2: 251.5
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXm2);
export default __webpack_public_path__ + "static/media/xm2.69fca5b1.svg";
export { ForwardRef as ReactComponent };